import { CheckboxQuestionV3 } from './question-checkbox';
import { DatetimeQuestionV3 } from './question-datetime';
import { DescriptionQuestionV3 } from './question-description';
import { DropdownQuestionV3 } from './question-dropdown';
import { FieldsBlocQuestionV3 } from './question-fieldsBloc';
import { HiddenQuestionV3 } from './question-hidden';
import { ImageQuestionV3 } from './question-image';
import { MultiDropdownQuestionV3 } from './question-multiDropdown';
import { NestedGroupQuestionV3 } from './question-nestedGroup';
import { NumberRangeQuestionV3 } from './question-numberRange';
import { PhotoQuestionV3 } from './question-photo';
import { RadioQuestionV3 } from './question-radio';
import { RangeQuestionV3 } from './question-range';
import { SemanticQuestionV3 } from './question-semantic';
import { SocialSecurityQuestionV3 } from './question-social-security';
import { TextQuestionV3 } from './question-text';
import { TextAreaQuestionV3 } from './question-textarea';
import { ToggleQuestionV3 } from './question-toggle';
import { SignaturePadV3 } from './question-signature-pad';
import { VideoQuestionV3 } from '../../dynamic-form-v3/classes/question-video';
import { ButtonQuestionV3 } from './question-button';
import { TimeQuestionV3 } from './question-time';

export enum QuestionV3ControlTypes {
  CHECKBOX,
  DATETIME,
  DROPDOWN,
  DESCRIPTION,
  IMAGE,
  MULTI_DROPDOWN,
  NESTED_GROUP,
  NUMBER_RANGE,
  RADIO,
  RANGE,
  SEMANTIC,
  SOCIAL_SECURITY,
  TEXT,
  TEXTAREA,
  TOGGLE,
  EQ5,
  HTML,
  PHOTO,
  FIELDS_BLOC,
  FILE,
  HIDDEN,
  SIGNATURE_PAD,
  VIDEO,
  BUTTON,
  TIME
}

export enum ConstraintTypesV3 {
  REQUIRED = 'required',
  RANGE = 'range',
  MAXLENGTH = 'maxlength',
  MINLENGTH = 'minlength',
  LENGTH = 'len',
  EMAIL = 'email',
  MIN = 'min',
  MAX = 'max',
  PATTERN = 'pattern',
  LIMIT_CONDITION = 'limitCondition',
  MAXSIZE = 'maxSize',
  ALLOWED_EXTENSION = 'allowedExtension'
}

// export enum ConstraintTypes {
//   REQUIRED = 'required',
//   RANGE = 'range',
//   MAXLENGTH = 'maxLen',
//   LENGTH = 'len',
//   EMAIL = 'email',
//   MIN = 'min',
//   MAX = 'max',
//   PATTERN = 'pattern',
//   LIMIT_CONDITION = 'limitCondition',
//   MAXSIZE = 'maxSize'
// }

export type QuestionsV3 =
  | CheckboxQuestionV3
  | DatetimeQuestionV3
  | DropdownQuestionV3
  | DescriptionQuestionV3
  | ImageQuestionV3
  | MultiDropdownQuestionV3
  | NestedGroupQuestionV3
  | NumberRangeQuestionV3
  | RadioQuestionV3
  | RangeQuestionV3
  | SemanticQuestionV3
  | SocialSecurityQuestionV3
  | TextQuestionV3
  | TextAreaQuestionV3
  | ToggleQuestionV3
  | PhotoQuestionV3
  | FieldsBlocQuestionV3
  | HiddenQuestionV3
  | SignaturePadV3
  | VideoQuestionV3
  | ButtonQuestionV3
  | TimeQuestionV3;

export enum NumericComparison {
  eq,
  neq,
  lt,
  lte,
  gt,
  gte
}

export enum ConditionalRuleTypes {
  DISPLAY_CONDITION = 'display_condition',
  COMPULSORY_CONDITION = 'compulsory_condition',
  LIMIT_CONDITION = 'boundary_condition'
}

export interface ConditionalRuleType {
  type: string;
  expression: string;
  normalizeExpression?: string;
  result?: boolean;
}

export enum SupportedVideoType {
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo'
}
